import { render, staticRenderFns } from "./DashboardPunchClock.vue?vue&type=template&id=6c524cad&scoped=true&"
import script from "./DashboardPunchClock.vue?vue&type=script&lang=js&"
export * from "./DashboardPunchClock.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPunchClock.vue?vue&type=style&index=0&id=6c524cad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c524cad",
  null
  
)

export default component.exports